import { format } from 'date-fns';

export function formatActivityDateTime(date: string, time: string): string {
  const dateObj = new Date(`${date}T${time}`);
  return format(dateObj, "dd/MM/yyyy '@'HH:mm");
}